import { useEffect, useState } from "react";
import { checkin, getUncheckedParticipantsLogs } from "./apiRoutes/events";
import {
  Loader2,
  TriangleAlert,
  CircleCheckBig,
  X,
  CheckCircle,
  Box,
} from "lucide-react";
import { ClipLoader } from "react-spinners";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Sidebar from "../../customComponents/Sidebar/Sidebar";
import { Button, Container, Typography } from "@mui/material";
import { getEventLogs } from "../SubscriberPortal/apiRoutes/eventLogs";
import { getEvents } from "../../mainApiRoutes/events";

const query = new URLSearchParams(window.location.search);

export default function EventList() {
  const [wpEvents, setWpEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [selectedSections, setSelectedSections] = useState({
    upcomingEvents: false,
    activeEvents: true,
    pastEvents: false,
  });

  useEffect(() => {
    if (!wpEvents.length) return;

    const now = new Date();

    const events = wpEvents.map((e) => ({
      ...e,
      start: new Date(e.start_date.replace(" ", "T")),
      end: new Date(e.end_date.replace(" ", "T")),
    }));

    let result = [];

    if (selectedSections.upcomingEvents) {
      result = events.filter((e) => e.start > now);
    }

    if (selectedSections.activeEvents) {
      result = events.filter((e) => now >= e.start && now <= e.end);
    }

    if (selectedSections.pastEvents) {
      result = events.filter((e) => e.end < now);
    }

    setFilteredEvents(result);
  }, [wpEvents, selectedSections]);

  useEffect(() => {
    initializeEvents();
  }, []);

  const initializeEvents = async () => {
    const newWpEvents = await getEvents();
    setWpEvents(newWpEvents);
  };

  const handleSectionClicked = (field) => {
    const newSelectedSections = {
      upcomingEvents: false,
      activeEvents: false,
      pastEvents: false,
    };
    newSelectedSections[field] = true;
    setSelectedSections(newSelectedSections);
  };

  return (
    <div className="admin-portal-container">
      <Sidebar selectedIndex={2} />
      <div className="event-list-container">
        <div className="nav-menu">
          <NavMenuItem
            name={"Upcoming Events"}
            isSelected={selectedSections.upcomingEvents}
            onClick={() => handleSectionClicked("upcomingEvents")}
          />
          <NavMenuItem
            name={"Active Events"}
            isSelected={selectedSections.activeEvents}
            onClick={() => handleSectionClicked("activeEvents")}
          />
          <NavMenuItem
            name={"Past Events"}
            isSelected={selectedSections.pastEvents}
            onClick={() => handleSectionClicked("pastEvents")}
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            paddingTop: "0.25rem",
          }}
        >
          {filteredEvents.length > 0 && (
            <Typography
              variant="h1"
              component="h1"
              sx={{ fontWeight: 400, fontSize: "1.5rem" }}
            >
              {"Click Event to Open Walk-In Registration"}
            </Typography>
          )}
        </div>
        <div className="events-container">
          {filteredEvents.map((val) => (
            <EventItem
              address={val.location}
              name={val.title}
              onClick={() => {
                window.location.href = `/walk-in-registration/?event-id=${val.id}`;
              }}
              startDate={val.start_date}
            />
          ))}
          {filteredEvents.length === 0 && (
            <Container
              sx={{
                width: "100%",
                display: "flex",
                px: "1rem",
                justifyContent: "center",
                alignItems: "center",
                height: "10rem",
              }}
            >
              <Typography
                variant="h1"
                component="h1"
                sx={{ fontWeight: 400, fontSize: "1.5rem" }}
              >
                {selectedSections.activeEvents ? "No Active Events" : ""}
                {selectedSections.upcomingEvents ? "No Upcoming Events" : ""}
                {selectedSections.pastEvents ? "No Past Events" : ""}
              </Typography>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
}

function NavMenuItem({ name, isSelected = false, onClick }) {
  return (
    <div
      className={`nav-menu-item ${isSelected ? "selected" : ""}`}
      onClick={onClick}
    >
      <Typography
        variant="h6"
        component="h6"
        sx={{ fontWeight: 500, fontSize: "1.25rem" }}
      >
        {name}
      </Typography>
    </div>
  );
}

function EventItem({ name, address, startDate, onClick }) {
  const date = new Date(startDate.replace(" ", "T"));

  const monthShort = date
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();
  const day = date.getDate();
  const year = date.getFullYear();

  return (
    <div className="event-item">
      <div className="event-title-container">
        <div className="event-title">
          <Typography
            variant="h1"
            component="h1"
            sx={{ fontWeight: 600, fontSize: "1.75rem" }}
          >
            {name ? name : "Unknown Event"}
          </Typography>
        </div>
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 500, fontSize: "1rem" }}
        >
          {address}
        </Typography>
      </div>
      <Container
        sx={{
          width: "12rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button onClick={onClick}>WALK-IN REGISTER</Button>
      </Container>
      <div className="date-container">
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 600, fontSize: "1.75rem" }}
        >
          {day}
        </Typography>
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 600, fontSize: "1.25rem" }}
        >
          {monthShort}
        </Typography>
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 600, fontSize: "1rem" }}
        >
          {year}
        </Typography>
      </div>
    </div>
  );
}
